import React, { useState } from 'react';
import { Grid } from '@mui/material';
import DiaLetivoExtraMenu from './DiaLetivoExtraMenu';
import DiaLetivoExtraContainer from './DiaLetivoExtra/DiaLetivoExtraContainer';
import DiaLetivoExtraSerieContainer from './DiaLetivoExtraSerie/DiaLetivoExtraSerieContainer';

export const diaLetivoExtraKey = 'diaLetivoExtra';
export const diaLetivoExtraSerieKey = 'diaLetivoExtraSerie';

const DiaLetivoExtraMenuContainer = () => {
    const [menu, setMenu] = useState(diaLetivoExtraKey)

    return (
        <Grid
            justifyContent='center'
            container
            spacing={3}
        >
            <Grid size={8}>
                <DiaLetivoExtraMenu
                    menu={menu}
                    setMenu={setMenu}
                />
            </Grid>
            <Grid size={12}>
                {menu === diaLetivoExtraKey &&
                    <DiaLetivoExtraContainer />
                }
                {menu === diaLetivoExtraSerieKey &&
                    <DiaLetivoExtraSerieContainer />
                }
            </Grid>
        </Grid>
    );
}

export default DiaLetivoExtraMenuContainer;